import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const TieredInterventionContainer = styled.div`
  background-color: ${themeGet(
    'tieredInterventionCallout.tieredInterventionContainer.backgroundColor',
  )};
  border-radius: 0.688rem;
  padding: 2rem 1.75rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  top: -1.375rem;
  z-index: 10;

  ${themeGet('breakpoints.mobileLarge')} {
    padding: 1.5rem 1.25rem;
    top: -1.5rem;
  }
`

export const TieredInterventionTitle = styled.h2`
  font-family: ${themeGet('font.sharpSlab.bold')};
  font-weight: 700;
  font-size: 1.5rem;
  color: ${themeGet('colors.tieredIntervention.calloutText')};
  margin: 0 0 1rem 0;
  line-height: 1.2;

  ${themeGet('breakpoints.mobileLarge')} {
    font-size: 1.5rem;
  }
`

export const TieredInterventionDescription = styled.p`
  font-family: ${themeGet('font.molde.regular')};
  font-weight: 400;
  font-size: 1.125rem;
  color: ${themeGet('colors.tieredIntervention.calloutText')};
  margin: 0;
  line-height: 1.4;
  opacity: 0.95;

  ${themeGet('breakpoints.mobileLarge')} {
    font-size: 0.9375rem;
  }
`

export const TieredInterventionFooter = styled.div`
  margin-top: 1rem;
`
